import React from 'react';
import {Link} from "react-router-dom";

const NewTabLink = ({children,to, onClick, ...others}) => {
    return <Link {...others} to={to} target={'_blank'} onClick={e => {
        e.stopPropagation();
        if(onClick) {
            onClick(e);
        }
        // window.open(to, "_blank", "noreferrer");
    }}>{children}</Link>
};

export default NewTabLink;